<ul *ngIf="vm$ | async as vm" class="section-navbar" [ngClass]="positionClass$ | async" #listSections>
  <li *ngFor="let item of SECTIONS; let i = index; trackBy: trackBySection" [id]="'nav-item-' + i">
    <button
      type="button"
      (click)="click(item)"
      class="btn-clean section-navbar__btn"
      [class.section-navbar__active]="vm.currentNav === item.id"
      [class.section-navbar--new]="item.new"
    >
      <mat-icon
        class="icon"
        [svgIcon]="item.icon"
        [ngStyle]="{
          color: vm.currentNav === item.id && vm.isMobile === false ? 'white' : item.accentColor
        }"
        role="presentation"
      ></mat-icon>
      {{ vm.isMobile ? item.shortTitle : item.title }}
    </button>
  </li>
  <div class="cursor" [ngStyle]="vm.cursorStyle" aria-hidden="true"></div>
</ul>
